"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _analytics = require("../../../helpers/analytics");
var _Waves = _interopRequireDefault(require("../../Svg/TYWSymbols/Waves"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Email = function Email(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'tyw' : _ref$brand,
    emailAddress = _ref.emailAddress;
  var showDecoration = brand === 'tyw';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component position-relative"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, "Send us an email"), brand !== 'tyw' && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-md"
  }, "For any other enquiries please reach:"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: emailAddress,
    className: "".concat(_analytics.GA4_TRIGGERS.EMAIL_TEAM_CLASS, " d8-u-white-bg margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    link: "mailto:".concat(emailAddress),
    fullWidth: true
  })), brand === 'tyw' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-sm"
  }, "For all sales & general enquiries:"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "hello@theyachtweek.com",
    className: "".concat(_analytics.GA4_TRIGGERS.EMAIL_TEAM_CLASS, " d8-u-white-bg margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    link: "mailto:hello@theyachtweek.com",
    fullWidth: true
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-sm"
  }, "For collaborations & partnership interest:"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "partnerships@theyachtweek.com",
    className: "".concat(_analytics.GA4_TRIGGERS.EMAIL_TEAM_CLASS, " d8-u-white-bg margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    link: "mailto:partnerships@theyachtweek.com",
    fullWidth: true
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-sm"
  }, "All enquiries on how to become a skipper or host for Yach Week:"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "info@quarterdeck.co",
    className: "".concat(_analytics.GA4_TRIGGERS.EMAIL_TEAM_CLASS, " d8-u-white-bg margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    link: "mailto:info@quarterdeck.co",
    fullWidth: true
  })), showDecoration && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute width-100% height-100%",
    style: {
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute",
    style: {
      display: 'inline-block',
      bottom: 0,
      right: 0,
      zIndex: 0,
      opacity: 0.3
    }
  }, /*#__PURE__*/_react["default"].createElement(_Waves["default"], {
    className: "icon--xxxl",
    fill: "#FAE9DB"
  }))));
};
var _default = exports["default"] = Email;